import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Home, Wallet, Trophy, Zap, History, Gift, Settings, Bell, TrendingUp } from "lucide-react";

export default function OneXStavkaMain() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [browserTheme, setBrowserTheme] = useState('dark');

  useEffect(() => {
    const dataParam = searchParams.get('data');
    const themeParam = searchParams.get('theme');
    if (themeParam) setBrowserTheme(themeParam);
    if (dataParam) { 
      try { 
        setData(JSON.parse(decodeURIComponent(dataParam))); 
      } catch (e) {
        console.error('Parse error:', e);
      } 
    }
    document.title = '1xStavka - Ставки на спорт';
    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = '/1xstavka-favicon.svg';
  }, [searchParams]);

  if (!data) return <div className="min-h-screen bg-[#0a1628] flex items-center justify-center text-white">Загрузка...</div>;

  const isDark = browserTheme === 'dark';
  const theme = { bg: isDark ? '#202124' : '#dee1e6', activeTabBg: isDark ? '#292a2d' : '#ffffff', inactiveTabBg: isDark ? '#35363a' : '#c9cdd4', addressBarBg: isDark ? '#292a2d' : '#ffffff', addressInputBg: isDark ? '#202124' : '#f1f3f4', textPrimary: isDark ? '#e8eaed' : '#202124', textSecondary: isDark ? '#9aa0a6' : '#5f6368', border: isDark ? '#3c4043' : '#dadce0' };
  const accountName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Игрок';
  const userId = data.visibleId || '00000000';
  const balance = parseFloat(data.balance || 0);
  const bonusBalance = parseFloat(data.bonusBalance || 0);

  const menuItems = [
    { icon: Home, label: 'Главная', active: true }, { icon: Trophy, label: 'Линия', active: false },
    { icon: Zap, label: 'Live', active: false }, { icon: TrendingUp, label: 'Киберспорт', active: false },
    { icon: Wallet, label: 'Финансы', active: false }, { icon: History, label: 'История', active: false },
    { icon: Gift, label: 'Бонусы', active: false }, { icon: Settings, label: 'Настройки', active: false },
  ];

  const liveMatches = [
    { team1: 'Реал Мадрид', team2: 'Барселона', score: '1:2', time: '78\'', odds1: '3.20', oddsX: '3.40', odds2: '2.10', league: 'Ла Лига' },
    { team1: 'МЮ', team2: 'Ливерпуль', score: '0:1', time: '45+2\'', odds1: '2.80', oddsX: '3.20', odds2: '2.50', league: 'АПЛ' },
  ];

  const BrowserFrame = () => (
    <div style={{ backgroundColor: theme.bg }} className="flex-shrink-0">
      <div className="flex items-center h-[38px]">
        <div className="flex items-end flex-1 pl-2">
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px]" style={{ backgroundColor: theme.inactiveTabBg }}>
            <img src="/ozon-favicon.ico" alt="" className="w-4 h-4 mr-2" /><span className="text-[13px] truncate" style={{ color: theme.textSecondary }}>Ozon Карта</span>
          </div>
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px]" style={{ backgroundColor: theme.activeTabBg }}>
            <img src="/1xstavka-favicon.svg" alt="" className="w-4 h-4 mr-2" /><span className="text-[13px] truncate" style={{ color: theme.textPrimary }}>1xStavka</span>
          </div>
          <button className="w-7 h-7 flex items-center justify-center ml-1 mb-1" style={{ color: theme.textSecondary }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg></button>
        </div>
        <div className="flex items-center h-full">
          <button className="w-[46px] h-full flex items-center justify-center" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
        </div>
      </div>
      <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: theme.addressBarBg }}>
        <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: theme.addressInputBg, border: `1px solid ${theme.border}` }}>
          <svg className="w-4 h-4 mr-3" style={{ color: theme.textSecondary }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
          <span className="text-[14px]" style={{ color: theme.textPrimary }}>1xstavka.ru</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col template-preview-scale" style={{ backgroundColor: theme.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <BrowserFrame />
      <div className="flex-1 flex bg-[#0a1628]">
        <aside className="w-56 bg-[#0d1e36] flex flex-col flex-shrink-0 border-r border-[#1E40AF]/30">
          <div className="p-4"><img src="/1xstavka-logo.svg" alt="1xStavka" className="h-8" /></div>
          <nav className="flex-1 py-2">
            {menuItems.map((item, i) => { const Icon = item.icon; return (
              <a key={i} href="#" className={`flex items-center gap-3 px-4 py-2.5 text-sm ${item.active ? 'text-white bg-[#1E40AF]' : 'text-gray-400 hover:bg-white/5'}`}>
                <Icon className="w-5 h-5" /><span>{item.label}</span>
              </a>
            ); })}
          </nav>
        </aside>
        <div className="flex-1 flex flex-col min-w-0">
          <header className="bg-[#0d1e36] border-b border-[#1E40AF]/30 px-6 py-3 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-[#1E40AF]/20 border border-[#1E40AF]/50 rounded-lg px-4 py-2">
                <div className="text-xs text-gray-400">Баланс</div>
                <div className="text-lg font-bold text-white">{balance.toLocaleString('ru-RU')} ₽</div>
              </div>
              <div className="bg-[#00D4AA]/10 border border-[#00D4AA]/30 rounded-lg px-4 py-2">
                <div className="text-xs text-gray-400">Бонус</div>
                <div className="text-lg font-bold text-[#00D4AA]">{bonusBalance.toLocaleString('ru-RU')} ₽</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <button className="p-2 text-gray-400 relative"><Bell className="w-5 h-5" /><span className="absolute top-1 right-1 w-2 h-2 bg-[#1E40AF] rounded-full"></span></button>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-gradient-to-br from-[#1E40AF] to-[#1E3A8A] rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-bold">{accountName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}</span>
                </div>
                <div><div className="text-sm font-medium text-white">{accountName}</div><div className="text-xs text-gray-500">ID: {userId}</div></div>
              </div>
            </div>
          </header>
          <main className="flex-1 p-6 overflow-auto">
            <div className="bg-gradient-to-r from-[#1E40AF] to-[#1E3A8A] rounded-2xl p-6 mb-6 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <h2 className="text-2xl font-bold text-white mb-2">⚽ Фрибет 10 000 ₽</h2>
              <p className="text-white/80 mb-4">За первый депозит от 500 ₽!</p>
              <button className="px-6 py-2.5 bg-white text-[#1E40AF] rounded-lg font-bold hover:bg-gray-100">Получить</button>
            </div>
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2"><Zap className="w-5 h-5 text-[#00D4AA]" /> Live матчи</h3>
            <div className="space-y-3 mb-6">
              {liveMatches.map((m, i) => (
                <div key={i} className="bg-[#0d1e36] border border-[#1E40AF]/30 rounded-xl p-4">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-xs text-gray-500">{m.league}</span>
                    <span className="text-[#00D4AA] text-sm font-medium">{m.time}</span>
                  </div>
                  <div className="flex items-center justify-center gap-4 mb-3">
                    <span className="text-white font-medium">{m.team1}</span>
                    <span className="text-2xl font-bold text-[#1E40AF]">{m.score}</span>
                    <span className="text-white font-medium">{m.team2}</span>
                  </div>
                  <div className="flex gap-2">
                    <button className="flex-1 py-2 bg-[#1E40AF]/20 border border-[#1E40AF]/50 rounded-lg text-white hover:bg-[#1E40AF]/30">
                      <div className="text-xs text-gray-400">П1</div><div className="font-bold">{m.odds1}</div>
                    </button>
                    <button className="flex-1 py-2 bg-[#1E40AF]/20 border border-[#1E40AF]/50 rounded-lg text-white hover:bg-[#1E40AF]/30">
                      <div className="text-xs text-gray-400">X</div><div className="font-bold">{m.oddsX}</div>
                    </button>
                    <button className="flex-1 py-2 bg-[#1E40AF]/20 border border-[#1E40AF]/50 rounded-lg text-white hover:bg-[#1E40AF]/30">
                      <div className="text-xs text-gray-400">П2</div><div className="font-bold">{m.odds2}</div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-[#0d1e36] border border-[#1E40AF]/30 rounded-xl p-5">
              <h3 className="font-medium text-white mb-4">Последние ставки</h3>
              {(data.bets || []).slice(0, 3).map((b, i) => (
                <div key={i} className="flex items-center justify-between py-3 border-b border-[#1E40AF]/20 last:border-0">
                  <div><div className="text-sm font-medium text-white">{b.event || b.sport}</div><div className="text-xs text-gray-500">{b.date} • Кэф: {b.odds}</div></div>
                  <div className={`font-medium ${b.type === 'win' ? 'text-[#00D4AA]' : 'text-red-500'}`}>{b.type === 'win' ? `+${(parseFloat(b.amount) * parseFloat(b.odds)).toFixed(0)}` : `-${b.amount}`} ₽</div>
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
